import {ConsumerComplaintProviderModel} from './ConsumerComplaintProviderModel.js';
import {ConsumerComplaintPatientModel} from './ConsumerComplaintPatientModel.js';
import {ConsumerComplaintHealthPlanModel} from './ConsumerComplaintHealthPlanModel.js';
import {ConsumerComplaintDocumentModel} from './ConsumerComplaintDocumentModel.js';
import {ConsumerComplaintAuthorizedRepModel} from './ConsumerComplaintAuthorizedRepModel.js';
import { ConsumerComplaintTypeModel } from './ConsumerComplaintTypeModel.js';
import {helpers, required, requiredIf} from "@vuelidate/validators";
import {CONSUMER_COMPLAINT_PATIENT_RELATIONSHIPS} from "@/utils/constants.js";

export class ConsumerComplaintModel {
    constructor(data = {}) {
        this.complaintId = data.complaintId ?? null;
        this.complaintStatus = data.complaintStatus ?? 'Pending Information Insurance';
        this.summaryOfComplaint = data.summaryOfComplaint ?? '';
        this.doNotSendCopyToHmo = data.doNotSendCopyToHmo ?? false;
        this.signature = data.signature ?? null;
        this.signatureDate = data.signatureDate ?? null;
        this.signatureRelationship = data.signatureRelationship ?? null;
        this.complaintOutcome = data.complaintOutcome ?? null;
        this.mdhInvestigator = data.mdhInvestigator ?? null;
        this.complaintCategory = data.complaintCategory ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
        // init transient collection of types
        this.initComplaintTypes = data.initComplaintTypes ?? null;
        this.initProviders = data.initProviders ?? null;

        // Instantiate related models if present
        this.providers = Array.isArray(data.providers)
            ? data.providers.map(p => new ConsumerComplaintProviderModel(p))
            : data.provider
                ? [new ConsumerComplaintProviderModel(data.provider)]
                : [new ConsumerComplaintProviderModel()];
        this.complaintTypes = Array.isArray(data.complaintTypes)
            ? data.complaintTypes.map(t => new ConsumerComplaintTypeModel(t))
            : data.complaintType
                ? [new ConsumerComplaintTypeModel(data.complaintType)]
                : [new ConsumerComplaintTypeModel()];
        this.patient = data.patient ? new ConsumerComplaintPatientModel(data.patient) : new ConsumerComplaintPatientModel({});
        this.healthPlan = data.healthPlan ? new ConsumerComplaintHealthPlanModel(data.healthPlan) : new ConsumerComplaintHealthPlanModel({});
        this.documents = Array.isArray(data.documents) ? data.documents.map(d => new ConsumerComplaintDocumentModel(d)) : [];
        this.authorizedRep = data.authorizedRep ? new ConsumerComplaintAuthorizedRepModel(data.authorizedRep) : new ConsumerComplaintAuthorizedRepModel({});
    }

    getValidationRules() {
        return {
            providers: {
                $each: ConsumerComplaintProviderModel.getValidationRules()
            },
            patient: ConsumerComplaintPatientModel.getValidationRules(),
            authorizedRep: ConsumerComplaintAuthorizedRepModel.getValidationRules(this.patient.relationshipToPatient),
            healthPlan: ConsumerComplaintHealthPlanModel.getValidationRules(),
            summaryOfComplaint: {required: helpers.withMessage('Summary of Complaint is required', required)},
            signature: {required: helpers.withMessage('Signature is required', required)},
            signatureRelationship: {required: helpers.withMessage('Signature Relationship is required', requiredIf(() => this.patient.relationshipToPatient !== CONSUMER_COMPLAINT_PATIENT_RELATIONSHIPS.Self))},
        };
    }

    static save() {

    }
}


